module.exports = __webpack_public_path__ + "static/media/parent_slide_mobile_2.ea1a721a.png";